export default "__VITE_ASSET__CLFJ5ABZ__"